import { Fragment } from 'react';
import { LoadingSkeleton } from '../../../../common/components';
import GerencialesPieTableSection from '../GerencialesPieTableSection';
import { CHART_COLORS } from '../../constants/gerencialesConstants';
import { buildPieData } from '../../utils/gerencialesUtils';

/**
 * Renderiza el detalle del reporte gerencial.
 * @param {Object} props - Props del componente.
 * @param {boolean} props.loading - Estado de carga.
 * @param {Object|null} props.results - Resultados del reporte.
 * @param {Object|null} props.header - Header con metadata.
 * @returns {JSX.Element} Reporte gerencial.
 */
const ContractDetailsReport = ({ loading, results, header }) => {
  if (loading) {
    return <LoadingSkeleton />;
  }

  if (!results) {
    return null;
  }

  const feeTypeRows = results?.fee_type || [];
  const possessionRows = results?.possession || [];
  const clientTypeRows = results?.client_type || [];
  const feeTypePossessionRows = results?.fee_type_possession || [];
  const clientTypePossessionRows = results?.client_type_possession || [];

  const feeTypePie = buildPieData(feeTypeRows, 'label', 'count', CHART_COLORS.feeType);
  const possessionPie = buildPieData(possessionRows, 'label', 'count', CHART_COLORS.possession);
  const clientTypePie = buildPieData(clientTypeRows, 'label', 'count', CHART_COLORS.clientType);

  const feeTypePossessionPie = buildPieData(
    feeTypePossessionRows.map((row) => ({
      label: `${row.fee_type} ${row.possession === 'Con casa' ? 'C/casa' : 'S/casa'}`,
      count: row.count,
    })),
    'label',
    'count',
    CHART_COLORS.feeTypePossession
  );

  const clientTypePossessionPie = buildPieData(
    clientTypePossessionRows.map((row) => ({
      label: `${row.client_type} ${row.possession === 'Con casa' ? 'C/casa' : 'S/casa'}`,
      count: row.count,
    })),
    'label',
    'count',
    CHART_COLORS.clientTypePossession
  );

  return (
    <Fragment>
      <GerencialesPieTableSection
        title="Contratos por tipo de cuota"
        columns={[
          { key: 'label', label: 'Tipo cuota', align: 'left' },
          { key: 'count', label: 'Cantidad', align: 'center' },
        ]}
        rows={feeTypeRows}
        pieData={feeTypePie}
        totalLabel="Total contratos"
        totalCount={header?.total_contracts ?? 0}
        chartId="gerenciales-contract-details-fee-type"
      />

      <GerencialesPieTableSection
        title="Contratos por tipo de posesion"
        columns={[
          { key: 'label', label: 'Tipo posesion', align: 'left' },
          { key: 'count', label: 'Cantidad', align: 'center' },
        ]}
        rows={possessionRows}
        pieData={possessionPie}
        totalLabel="Total contratos"
        totalCount={header?.total_contracts ?? 0}
        chartId="gerenciales-contract-details-possession"
      />

      <GerencialesPieTableSection
        title="Contratos por tipo de cliente"
        columns={[
          { key: 'label', label: 'Tipo cliente', align: 'left' },
          { key: 'count', label: 'Cantidad', align: 'center' },
        ]}
        rows={clientTypeRows}
        pieData={clientTypePie}
        totalLabel="Total contratos"
        totalCount={header?.total_contracts ?? 0}
        chartId="gerenciales-contract-details-client-type"
      />

      <GerencialesPieTableSection
        title="Contratos por tipo de cuota y posesion"
        columns={[
          { key: 'fee_type', label: 'Tipo cuota', align: 'left' },
          { key: 'possession', label: 'Tipo posesion', align: 'left' },
          { key: 'count', label: 'Cantidad', align: 'center' },
        ]}
        rows={feeTypePossessionRows}
        pieData={feeTypePossessionPie}
        totalLabel="Total contratos"
        totalCount={header?.total_contracts ?? 0}
        chartId="gerenciales-contract-details-fee-type-possession"
      />

      <GerencialesPieTableSection
        title="Contratos por tipo de cliente y posesion"
        columns={[
          { key: 'client_type', label: 'Tipo cliente', align: 'left' },
          { key: 'possession', label: 'Tipo posesion', align: 'left' },
          { key: 'count', label: 'Cantidad', align: 'center' },
        ]}
        rows={clientTypePossessionRows}
        pieData={clientTypePossessionPie}
        totalLabel="Total contratos"
        totalCount={header?.total_contracts ?? 0}
        chartId="gerenciales-contract-details-client-type-possession"
      />
    </Fragment>
  );
};

export default ContractDetailsReport;
